import routes from 'sitewide-js/core_pre_webpack/routes';
import { keptAlivePost } from 'js/utils/kept_alive_post';

// NOTE: This click tracking is for clicks directly linked to impressions.
// For generalized click tracking, see js/utils/trackClick.ts
export function trackClick(target: string): void {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'hit_data' does not exist on type 'typeof... Remove this comment to see the full error message
  const hit_id = (window.Aedu && Aedu.hit_data && Aedu.hit_data.id) || null;
  const body = { hit_id, target };

  const url = routes.api_v0_on_site_clicks_path({ subdomain_param: 'api' });

  keptAlivePost(url, body);
}
